import api from './api';

export const marketService = {
  getData: async () => {
    const response = await api.get('/market/data');
    return response;
  },
};

export default marketService;
